module.exports = "/React/dist/d712745906928f4456063bae8249ad51.png";